"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSITIONING = exports.OPTIN_VIEW_NEW = exports.OPTIN_VIEW_CURRENT = void 0;
var OPTIN_VIEW_CURRENT = 'CURRENT';
exports.OPTIN_VIEW_CURRENT = OPTIN_VIEW_CURRENT;
var OPTIN_VIEW_NEW = 'NEW';
exports.OPTIN_VIEW_NEW = OPTIN_VIEW_NEW;
var POSITIONING = {
  position: 'fixed',
  bottom: '17px',
  left: '17px',
  zIndex: '900'
};
exports.POSITIONING = POSITIONING;